import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetFirmsResult } from './get-firms.result';

export async function getFirms(): Promise<GetFirmsResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetFirmsResult[]>(`/firms`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
